import React from "react"
import { Formik, Form } from "formik";
import Field from "content/Event/ScheduleEvent/multiTagField"
import Button from "storybookComponents/Button"
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import * as apis from "relay/event";
import { getEventTemplateFields } from "relay/event"
import Loader from "storybookComponents/Loader"

const SendTest = ({ showNotification, toggleModal, classes, username, emailId, emailName, smsEnabled }) => {

  const [templateDetails, setTemplateDetails] = React.useState()
  const [loading, setLoading] = React.useState(true)
  const [active, setActive] = React.useState(false)

  React.useEffect(() => {
    loadTemplateDetails();
  }, [1])


  const loadTemplateDetails = async () => {
    try {
      setLoading(true)
      let hyblastEditorResponse = await getEventTemplateFields(emailId)
      if (hyblastEditorResponse && hyblastEditorResponse.hyblastEditor) {
        setTemplateDetails(hyblastEditorResponse.hyblastEditor)
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const onSend = async (data) => {
    try {
      setActive(true)
      let recipients = [...data.emails, ...data.phones].toString()
      let payload = {
        id: emailId,
        recipients,
        bodyHtml: "auto",
        subject: templateDetails.subject
      }
      let response = await apis.testEmail(payload);
      if (response && response.testEmail && response.testEmail.hyblast) {
        showNotification("Test Email has been sent successfully", "success")
        toggleModal();
      }
      const uncachebleError = getErrorMessage(checkUncatchableError("testEmailMutation"));
      if (uncachebleError) {
        showNotification(uncachebleError, "error");
      }
      setActive(false)
    }
    catch (error) {
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
    }
  }
  if (loading) {
    return <div className={classes.loaderContainer}><Loader /></div>
  }


  return (
    <Formik initialValues={{
      emails: templateDetails.lastTestEmails ? templateDetails.lastTestEmails.split(',') : [username],
      phones: templateDetails.lastTestPhones ? templateDetails.lastTestPhones.split(',') : [],
    }}
      onSubmit={onSend}
    >
      {
        (props) => (
          <div className={classes.fontDetails}>
            <div className={classes.printDescription}>Add your email(s) {smsEnabled ? "and phone number(s) " : ""}below to test the {emailName} before publishing them
            </div>
            <Field {...props} keyName="emails" label="Email(s)" description="Enter emails separated by commas" />
            {
              smsEnabled ? <Field {...props} regex={/^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$/} mask="XXX-XXX-XXXX" restrictText keyName="phones" label="Phone Number(s)" description="Enter phone numbers separated by commas" /> : null
            }
            <div className={classes.buttonsContainer}>
              <Button color="darkBlack" variant="tertiary" size="md" className={classes.modalButtonStyle} onClick={toggleModal}>
                <strong>Cancel</strong>
              </Button>
              <Button color="hylyBlue" type="submit" state={active || (!props.values.emails.length && !props.values.phones.length) ? "inactive" : "active"} variant="primary" className={classes.modalButtonStyle} size="md" onClick={props.handleSubmit}>
                <strong>Send Test</strong>
              </Button>
            </div>
          </div>
        )
      }
    </Formik>
  )
}

export default SendTest